import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { IconBuilding } from "../../Assets/contacts/IconBuilding";
import { setMetaTags, setReachDataType } from "../Functions/SetHeaders";
import { IconStar } from "../../Assets/panels/IconStar";
import { useLocation } from "react-router-dom";

const Styles = styled.div`
  .hotel-info {
    margin-right: 20px;
    margin-left: 20px;
  }

  .back-drop {
    width: 100%;
    height: 30vh;
    overflow: hidden;
    border-radius: 0 0 var(--border-radius-3) var(--border-radius-3);
    position: relative;
    isolation: isolate;
    background-color: var(--prime-1);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: blur(10px);
    }
    &::after {
      z-index: 2;
      content: " ";
      position: absolute;
      inset: 0;
      background-color: #00000030;
    }
  }

  .over-hotel {
    width: calc(100% - calc(var(--universal-pad) * 2) - 2.5rem);
    margin: -10vh auto 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .image {
      width: 30%;
      max-width: 300px;
      aspect-ratio: 1.8;
      border: 1px solid var(--n-grey-1);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      background-color: var(--n-grey-01);
      img {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .hotel-name {
        font-size: 1.5rem;
        font-weight: 700;
      }

      .desc {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        color: var(--n-grey-2);
      }

      .desc span {
        font-weight: bold;
      }
    }
  }

  .over-hotel-d {
    width: calc(100% - calc(var(--universal-pad) * 2) - 2.5rem);
    margin: 1rem auto 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    p {
      margin: 0.5rem 0;
      span {
        font-weight: bold;
      }
    }
  }

  .extra-details {
    margin: 1rem auto;
    /* padding: 1rem; */
    padding: 0 var(--universal-pad);
    border-radius: var(--border-radius-3);

    .image-gallery {
      display: flex;
      /* justify-content: center; */
      flex-wrap: wrap;
      gap: 1rem;
      img {
        flex-grow: 1;
        max-width: calc(100% / 3);
        height: 200px;
        border-radius: var(--border-radius-3);
        object-fit: cover;
      }
    }

    .hotel-info {
      margin-top: 1rem;
      font-size: 1rem;
      line-height: 1.5;

      p {
        margin: 0.5rem 0;
        span {
          font-weight: bold;
        }
      }
    }
  }

  .starsp {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .stars {
    font-size: 1rem;
    font-weight: 500;
    color: var(--n-grey-2);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    svg {
      fill: var(--n-grey-2);
      &.active {
        fill: #fcca3d;
      }
    }
  }

  .star {
    width: 20px;
    height: 20px;
    background-color: var(--c-main);
    clip-path: polygon(
      50% 0%,
      61% 35%,
      98% 35%,
      68% 57%,
      79% 91%,
      50% 70%,
      21% 91%,
      32% 57%,
      2% 35%,
      39% 35%
    );
    opacity: 0.5;
  }

  .star-filled {
    background-color: gold;
    opacity: 1;
  }

  @media screen and (max-width: 850px) {
    .over-hotel {
      width: calc(95% - calc(var(--universal-pad) * 2));
      padding: 1rem;
      flex-direction: column;
      align-items: normal;
      gap: 1rem;
      .image {
        width: 100%;
        max-width: none;
        aspect-ratio: 2.5;
      }
      .expand {
        display: none;
      }
    }
    .extra-details {
      display: flex;
      flex-direction: column;

      img {
        min-width: calc(100% - calc(var(--universal-pad) * 2));
        min-height: 300px;
        border-radius: var(--border-radius-3);
        object-fit: cover;
      }
    }

    .over-hotel-d {
      width: calc(95% - calc(var(--universal-pad) * 2));
    }
  }
`;

function HotelsMain38(props) {
  const location = useLocation()
  const { hotels = {}, lan, pageDataMeta } = props;

  useEffect(() => {
    const hotelName = getHotelData("Name");
    let title = "Hotel Information";

    if (hotelName) {
      title =
        lan.filename === "fa"
          ? `${hotelName} - لوکسین تریپ`
          : `${hotelName} - Luxintrip`;
    }

    if (pageDataMeta?.Country?.Country_En_Name) {
      title += `, ${pageDataMeta.Country.Country_En_Name}`;
    } else if (pageDataMeta?.Continent?.Continent_EnName) {
      title += `, ${pageDataMeta.Continent.Continent_EnName}`;
    }

    setMetaTags(title, "", hotels.Hotel_Indexable ? "" : "noindex");


  if (hotels) {
    let hotel = {
      "@type" : "Hotel",
      "@id": "https://luxintrip.com" + location.pathname + "/#Hotel",
      "name": lan.filename === "fa" ? hotels.Hotel_Name : hotels.Hotel_En_Name,
      "description": lan.filename === "fa" ? hotels.Hotel_Desc : hotels.Hotel_En_Desc,
      "image": hotels.Agency_Logo,
      "url": "https://luxintrip.com" + location.pathname,
      "address": {
        "@type": "PostalAddress",
        "name": lan.filename === "fa" ? hotels.Hotel_Address : hotels.Hotel_En_Address,
      }
    }
    setReachDataType("Hotel", hotel);
  }

  }, [hotels, lan, pageDataMeta]);

  const renderStars = (num) => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
        stars.push(
            <IconStar className={((i < num) ? "active" : "")}/>
        );
    }
    return <div>{stars}</div>
  }
  const getHotelData = (key) => {
    if (lan.filename === "fa") {
      return hotels[key] || hotels[`Hotel_${key}`] || "اطلاعات موجود نیست";
    } else {
      return (
        hotels[`Hotel_En_${key}`] || hotels[key] || "Information not available"
      );
    }
  };

  

  return (
    <Styles>
      <div className="back-drop">
        {hotels.Hotel_Logo && (
          <img
            src={hotels.Hotel_Logo}
            alt={getHotelData("Name")}
            onError={(e) => (e.target.style.opacity = 0)}
          />
        )}
      </div>
      <div className="over-hotel">
        <div className="image">
          <img src={hotels?.Hotel_Logo || ""} alt={getHotelData("Name")} />
        </div>
        <div className="info">
          <div className="hotel-name">{getHotelData("Name")}</div>
          <div className="desc">
            <p className="starsp">
              <span>
                {lan.filename === "fa" ? "تعداد ستاره:" : "Number of stars:"}
              </span>
              <div className="stars">
                {renderStars(hotels?.Hotel_Star || 0)}
              </div>
            </p>
          </div>
          <div className="desc">
            <p>
              <span>{lan.filename === "fa" ? "آدرس:" : "Address:"}</span>{" "}
              {getHotelData("Address")}
            </p>
          </div>
        </div>
      </div>

      <div className="extra-details">
        <div className="image-gallery">
          {[hotels.Hotel_Image1, hotels.Hotel_Image2, hotels.Hotel_Image3]
            .filter(Boolean)
            .map((image, index) => (
              (image && image !== "null") ? <img key={index} src={image} alt={`Hotel image ${index + 1}`} /> : ""
            ))}
        </div>
      </div>

      <div className="over-hotel-d">
        <div className="hotel-info">
          <p>
            <span>{lan.filename === "fa" ? "تلفن:" : "Phone:"}</span>{" "}
            {getHotelData("Tel_No")}
          </p>
          <p>
            <span>{lan.filename === "fa" ? "امکانات:" : "Amenities:"}</span>{" "}
            {getHotelData("Desc")}
          </p>
          <p>
            <span>
              {lan.filename === "fa" ? "زمان ورود:" : "Check-in time:"}
            </span>{" "}
            {getHotelData("CheckIn")}
          </p>
          <p>
            <span>
              {lan.filename === "fa" ? "زمان خروج:" : "Check-out time:"}
            </span>{" "}
            {getHotelData("CheckOut")}
          </p>
        </div>
      </div>
    </Styles>
  );
}

export default HotelsMain38;
